import { Grid } from '@mui/material';
import { type Path } from 'react-hook-form';
import {
  SelectDropdownWidget,
  SwitchButtonWidget,
} from 'src/components/widget';
import { CURRENCY_POSITION_OPTIONS } from 'src/constants';
import { useGetProjectConfig } from 'src/hooks';
import { CircularCurrencies } from 'src/interfaces';

import type { CodGlobalSetting } from '../CODForm.interface';
import { CustomCodSettingsProps } from './CustomCodSettings.interface';

export const CustomCodSettings = (props: CustomCodSettingsProps) => {
  const { data: projectConfig } = useGetProjectConfig();

  const handleFieldChange = (field: Path<CodGlobalSetting>) => (value: any) => {
    props.onChange(`codSettings.globalSetting.${field}`, value);
  };

  const disabledCurrencyToggle = !Boolean(
    props.globalSetting?.productPriceCurrency ??
      projectConfig?.productPriceCurrency,
  );

  return (
    <Grid container spacing={2} padding={3}>
      <Grid item xs={12}>
        <SwitchButtonWidget
          label="Show currency symbol on prices"
          value={Boolean(
            props.globalSetting?.productPriceCurrency ??
              projectConfig?.productPriceCurrency,
          )}
          onChange={(value) =>
            handleFieldChange('productPriceCurrency')(
              value ? CircularCurrencies[0].value : '',
            )
          }
          hasError={!!props.errors?.productPriceCurrency}
          error={props.errors?.productPriceCurrency?.message}
        />
      </Grid>
      <Grid item xs={12}>
        <SelectDropdownWidget
          label="Currency position"
          value={
            props.globalSetting?.productPriceCurrencyPosition ??
            projectConfig?.productPriceCurrencyPosition
          }
          selectOptions={CURRENCY_POSITION_OPTIONS}
          onChange={handleFieldChange('productPriceCurrencyPosition')}
          hasError={!!props.errors?.productPriceCurrencyPosition}
          error={props.errors?.productPriceCurrencyPosition?.message}
        />
      </Grid>
      <Grid item xs={12}>
        <SelectDropdownWidget
          label="Currency"
          value={
            props.globalSetting?.productPriceCurrency ??
            projectConfig?.productPriceCurrency
          }
          selectOptions={CircularCurrencies.map((currency) => ({
            label: currency.label,
            value: currency.value,
          }))}
          disabled={disabledCurrencyToggle}
          onChange={handleFieldChange('productPriceCurrency')}
          hasError={!!props.errors?.productPriceCurrency}
          error={props.errors?.productPriceCurrency?.message}
        />
      </Grid>
      <Grid item xs={12}>
        <SelectDropdownWidget
          label="Pricing separator"
          value={
            props.globalSetting?.productPriceDecimalSeparator ??
            projectConfig?.productPriceDecimalSeparator
          }
          selectOptions={[
            { label: '. - Dot', value: '.' },
            { label: ', - Comma', value: ',' },
          ]}
          onChange={handleFieldChange('productPriceDecimalSeparator')}
          hasError={!!props.errors?.productPriceDecimalSeparator}
          error={props.errors?.productPriceDecimalSeparator?.message}
        />
      </Grid>
      <Grid item xs={12}>
        <SwitchButtonWidget
          label="Show full price only"
          value={
            props.globalSetting?.productFullPriceOnly ??
            projectConfig?.productFullPriceOnly
          }
          onChange={handleFieldChange('productFullPriceOnly')}
          hasError={!!props.errors?.productFullPriceOnly}
          error={props.errors?.productFullPriceOnly?.message}
        />
      </Grid>
    </Grid>
  );
};
